import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://orhldclezkvhwvnygrbm.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9yaGxkY2xlemt2aHd2bnlncmJtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU0MDgxMDQsImV4cCI6MjA3MDk4NDEwNH0.QihrSPD0XimBfsnToNFdDCP9CIYGuuaSy4jR0YPfZDg';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
